module.exports = __webpack_public_path__ + "img/success.84daa987.png";